import IndicatorsBand from "../../IndicatorsBand/IndicatorsBand";
import { normalizeCityIndicators } from "../../../utils/cityIndicators";

export default function NucleoIndicadores({
  indicators: indicatorsProp,
  imageUrl,
  fallbackIndicators = [],
  showOverlay = true,
}) {
  const indicators = normalizeCityIndicators(
    indicatorsProp,
    fallbackIndicators,
  );
  const normalizedIndicators = indicators.map((item) => ({
    ...item,
    label: item.label,
    description: item.description,
  }));

  return (
    <IndicatorsBand
      title="Nossos indicadores"
      imageUrl={imageUrl}
      indicators={normalizedIndicators}
      compact
      showOverlay={showOverlay}
      className="regional-hub-indicators"
    />
  );
}
